import { EditGroupMode } from '@models/OpportunityReview';
import { FeatureOption } from '@utils/pageConfig/Types';
import React, { useContext } from 'react';

export interface OpportunityReviewBoardGroupType {
  selectedSegments: string[];
  selectSegments: (pg: string) => void;
  clearSelectedSegments: () => void;
  isSegmentsSelected: (pg: string) => boolean;
  setSelectedSegments: (segments: string[]) => void;
  isCreateModalGroupPopUp: boolean;
  setIsCreateModalGroupPopUp: (value: boolean) => void;
  groupNameToBeDelete: string;
  setGroupNameToBeDelete: (groupName: string) => void;
  isDeleteModalGroupPopUp: boolean;
  setIsDeleteModalGroupPopUp: (value: boolean) => void;
  isShareModalGroupPopUp: boolean;
  setIsShareModalGroupPopUp: (value: boolean) => void;
  isEditGroupMode: EditGroupMode;
  setIsEditGroupMode: (editGroup: EditGroupMode) => void;
  resetGroupingState: () => void;
  currentSelectedFeature: FeatureOption;
  setCurrentSelectedFeature: (featureOption: FeatureOption) => void;
}

export const OpportunityReviewBoardGroupContext = React.createContext<OpportunityReviewBoardGroupType>(
  {} as OpportunityReviewBoardGroupType,
);

export const useOpportunityReviewBoardGroupEventState = (): OpportunityReviewBoardGroupType => {
  return useContext(OpportunityReviewBoardGroupContext);
};
